import { render } from "./TalentProfile.vue?vue&type=template&id=0cbf6cb1&scoped=true"
import script from "./TalentProfile.vue?vue&type=script&lang=js"
export * from "./TalentProfile.vue?vue&type=script&lang=js"

import "./TalentProfile.vue?vue&type=style&index=0&id=0cbf6cb1&lang=scss&scoped=true"
import "./TalentProfile.vue?vue&type=style&index=1&id=0cbf6cb1&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cbf6cb1"]])

export default __exports__